import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, ViewEncapsulation, ChangeDetectorRef, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MobileNavigationComponent } from '../../common/components/mobile-navigation/mobile-navigation.component';
import { SeoService } from '../../services/meta.service';
@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MobileNavigationComponent
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoComponent implements OnInit {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly seoService = inject(SeoService);
  ngOnInit(): void {
    this.seoService.setMetaTags({
      title: 'Wire Festival | Info',
      description: 'Wire Festival Info',
      keywords: 'Wire Festival Info'
    });
  }
  onImageLoad(event: Event) {
    const img = event.target as HTMLImageElement;
    img.classList.add('loaded');
    this.cdr.detectChanges();
  }
  onImageError(event: Event) {
    const img = event.target as HTMLImageElement;
    img.classList.add('error');
    this.cdr.detectChanges();
  }
}
